import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { Box } from '@mui/material'

import { BindTypeInputs } from '@components/BindTypeInputs'

import { GANTT_ICON_BIND_TYPE } from '@constants'
import { AutocompleteOption } from '@types'

import { getBindTypeOptionsByEnum } from '@gantt/helpers'

type SegmentLabelsFieldsProps = {
  watchedObject?: AutocompleteOption<string> | null
  existingPaths?: string[]
}

const labelHints = {
  js: i18next.t('ganttCreate.timelineForm.hint.cornersScriptHint'),
}

export const SegmentIconsFields = ({ watchedObject, existingPaths }: SegmentLabelsFieldsProps) => {
  const { t } = useTranslation()
  const isDisabled = !watchedObject

  const fieldPicker = useMemo(() => {
    return {
      existingPaths,
    }
  }, [existingPaths])

  const bindTypeOptions = getBindTypeOptionsByEnum(GANTT_ICON_BIND_TYPE)

  return (
    <Box>
      <BindTypeInputs
        bindTypeOptions={bindTypeOptions}
        blockLabel={t('ganttCreate.timelineForm.leftTopIcon')}
        containerName='icons.leftTopIcon'
        fieldPicker={fieldPicker}
        hintDict={labelHints}
        isDisabled={isDisabled}
        object={watchedObject}
      />
      <BindTypeInputs
        bindTypeOptions={bindTypeOptions}
        blockLabel={t('ganttCreate.timelineForm.topIcon')}
        containerName='icons.topIcon'
        fieldPicker={fieldPicker}
        hintDict={labelHints}
        isDisabled={isDisabled}
        object={watchedObject}
      />
      <BindTypeInputs
        hasDivider
        bindTypeOptions={bindTypeOptions}
        blockLabel={t('ganttCreate.timelineForm.rightTopIcon')}
        containerName='icons.rightTopIcon'
        fieldPicker={fieldPicker}
        hintDict={labelHints}
        isDisabled={isDisabled}
        object={watchedObject}
      />

      <BindTypeInputs
        bindTypeOptions={bindTypeOptions}
        blockLabel={t('ganttCreate.timelineForm.leftIcon')}
        containerName='icons.leftIcon'
        fieldPicker={fieldPicker}
        hintDict={labelHints}
        isDisabled={isDisabled}
        object={watchedObject}
      />
      <BindTypeInputs
        bindTypeOptions={bindTypeOptions}
        blockLabel={t('ganttCreate.timelineForm.centerIcon')}
        containerName='icons.centerIcon'
        fieldPicker={fieldPicker}
        hintDict={labelHints}
        isDisabled={isDisabled}
        object={watchedObject}
      />
      <BindTypeInputs
        hasDivider
        bindTypeOptions={bindTypeOptions}
        blockLabel={t('ganttCreate.timelineForm.rightIcon')}
        containerName='icons.rightIcon'
        fieldPicker={fieldPicker}
        hintDict={labelHints}
        isDisabled={isDisabled}
        object={watchedObject}
      />

      <BindTypeInputs
        bindTypeOptions={bindTypeOptions}
        blockLabel={t('ganttCreate.timelineForm.rightBottomIcon')}
        containerName='icons.rightBottomIcon'
        fieldPicker={fieldPicker}
        hintDict={labelHints}
        isDisabled={isDisabled}
        object={watchedObject}
      />
      <BindTypeInputs
        bindTypeOptions={bindTypeOptions}
        blockLabel={t('ganttCreate.timelineForm.bottomIcon')}
        containerName='icons.bottomIcon'
        fieldPicker={fieldPicker}
        hintDict={labelHints}
        isDisabled={isDisabled}
        object={watchedObject}
      />
      <BindTypeInputs
        bindTypeOptions={bindTypeOptions}
        blockLabel={t('ganttCreate.timelineForm.leftBottomIcon')}
        containerName='icons.leftBottomIcon'
        fieldPicker={fieldPicker}
        hintDict={labelHints}
        isDisabled={isDisabled}
        object={watchedObject}
      />
    </Box>
  )
}
